exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-skrflooring-index-tsx": () => import("./../../../src/pages/skrflooring/index.tsx" /* webpackChunkName: "component---src-pages-skrflooring-index-tsx" */),
  "component---src-pages-skrflooring-skr-flooring-tsx": () => import("./../../../src/pages/skrflooring/SKRFlooring.tsx" /* webpackChunkName: "component---src-pages-skrflooring-skr-flooring-tsx" */)
}

